import { GeoBlockingTemplate } from '@img-arena/consoles-api-streaming'
import { streamingRestApi } from '@/service/streamingApi'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'

type GeoBlockingTemplateParsed = Omit<GeoBlockingTemplate, 'geoListField'> & {
  geoListField: string[]
}

const useGeoTemplateStore = async (
  args: FetchApiArgs<undefined, string>
): Promise<FetchApiResponse<GeoBlockingTemplateParsed>> => {
  const { signal } = args

  const data =
    await streamingRestApi.endpoints.geoBlockingTemplatesEndpoints.getGeoBlockingTemplate(signal)

  return {
    content: data.map((template: GeoBlockingTemplate): GeoBlockingTemplateParsed => {
      try {
        return {
          ...template,
          geoListField: JSON.parse(template.geoListField)
        }
      } catch (e) {
        return {
          ...template,
          geoListField: []
        }
      }
    }),
    totalElements: data.length
  }
}

export const useGeoBlockingTemplatesStore = createBaseTableStore({
  storeName: 'GeoBlockingTemplates Store',
  fetchApi: useGeoTemplateStore
})
